export interface Meta {
  title?: string;
  description?: string;
  canonicalURL?: string;
}

export const metaFromResponse = (responseData: any): Meta => ({
  title: responseData.title,
  description: responseData.description,
  canonicalURL: responseData.canonical_url,
});

export const getEmptyMeta = (): Meta => ({});
